import Tag from 'components/Tag';
import React from 'react';

const TagsContainer = ({
  id,
  tags,
  handleTagsModal,
  handleTagsSubmit
}: {
  id: number;
  tags: any[];
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  handleTagsModal: (e: number) => void;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  handleTagsSubmit: (e: any, i: number) => void;
}) => {
  return (
    <div className="actionsContainer actionsTagContainer">
      {tags.map((tag) => (
        // @ts-expect-error Tag is js file, no validation
        <Tag
          icon="close"
          iconPosition="right"
          onClickIcon={() => handleTagsSubmit(tag, id)}
          key={`id_tag_${tag.name}`}
          id={`id_tag_${tag.name}`}
          label={tag.name}
          style={{
            marginBottom: 5,
            minHeight: 25,
            fontSize: 12,
            backgroundColor: 'rgba(134,142,150, 0.1)',
            color: '#868e96',
            border: 'none'
          }}
        />
      ))}
      <div className="addTagContainer">
        {/* @ts-expect-error Tag is js file, no validation */}
        <Tag
          label="+"
          onClick={() => handleTagsModal(id)}
          style={{
            marginBottom: 5,
            minHeight: 25,
            height: 'auto',
            width: 18,
            fontSize: 12,
            backgroundColor: 'rgba(134,142,150, 0.1)',
            color: '#868e96',
            border: 'none'
          }}
        />
      </div>
    </div>
  );
};

export default TagsContainer;
